import { Box, Container, Grid, Grid2 } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import riteCharleeDashboard from "../../assets/imgs/Dashboards/riteCharleeDashboard.png";
import riteCover from "../../assets/imgs/icons/rite-cover.png";
import { BookPopup } from "../modals/BookPopup";

const HOME_HEADER_HEIGHT = 79; // match your HomeHeader height

export const RiteCharleeHero = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const tagRef = useRef(null);
  const dropdownRef = useRef(null);
  const year = new Date().getFullYear();

  const [isOpenBook, setIsOpenBook] = useState(false);

  const handleCloseBook = () => {
    setIsOpenBook(false);
  };

  const handleOpenBook = () => {
    setIsOpenBook(true);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const onClickAway = (e) => {
      if (!menuOpen) return;
      const t = e.target;
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(t) &&
        tagRef.current &&
        !tagRef.current.contains(t)
      ) {
        setMenuOpen(false);
      }
    };
    window.addEventListener("click", onClickAway);
    return () => window.removeEventListener("click", onClickAway);
  }, [menuOpen]);

  return (
    <div>
      {/* Scoped styles (prefixed with .ram- to avoid leaking) */}
      <style>{`
        li {
          padding-top:10px;
          padding-bottom:0px;
        }

        .ram-root {
          --bg: #0a0c10;
          --panel: #0f131a;
          --panel-2: #121722;
          --text: #e6e9ef;
          --muted: #a7b0c0;
          --brand: #0b5cff;
          --brand-2: #8ab4ff;
          --ok: #1fbf75;
          --warn: #ffd166;
          --danger: #ff5d5d;
          --card-radius: 10px;
          --shadow: 0px 10px 10px rgba(0,0,0,.1);
          --maxw: 1100px;
          --offset: ${HOME_HEADER_HEIGHT}px;

          // color: var(--text);
          // background:
          //   radial-gradient(1200px 800px at 10% -10%, rgba(11,92,255,.15), transparent 60%),
          //   radial-gradient(1200px 800px at 110% 10%, rgba(138,180,255,.1), transparent 60%),
          //   var(--bg);
          line-height: 1.55;
          font-family: sans-serif
          letter-spacing: normal; /* avoid tight tracking */
          text-align: left;       /* do not inherit center from parents */
        }

        .ram-container { max-width: var(--maxw); margin: 0 auto; padding: 24px; }

        /* Page header (sticks below HomeHeader) */
        .ram-header {
          position: sticky;
          top: var(--offset);
          z-index: 50;
          backdrop-filter: saturate(140%) blur(10px);
          background: linear-gradient(180deg, rgba(10,12,16,.9), rgba(10,12,16,.6));
          border-bottom: 1px solid rgba(255,255,255,.06);
        }
        .ram-nav { display:flex; align-items:center; justify-content:space-between; gap:16px; }
        .ram-logo { display:flex; align-items:center; gap:12px; text-decoration:none; color:var(--text); }
        .ram-mark { width:28px; height:28px; display:grid; place-items:center; border-radius:8px; background:linear-gradient(135deg, var(--brand), #2b90ff); box-shadow: var(--shadow); }
        .ram-word { font-weight:700; letter-spacing:.2px; }

        .ram-cta { display:flex; gap:10px; }
        .ram-btn {
          --padx: 14px; --pady: 10px;
          padding: var(--pady) var(--padx);
          border-radius: 999px;
          border: 1px solid rgba(255,255,255,.12);
          color: var(--text);
          text-decoration: none;
          font-weight: 600; font-size: 12px;
          transition: transform .06s ease, background .2s ease, border-color .2s ease;
        }
        .ram-btn:hover { transform: translateY(-1px); }
        .ram-btn.primary { background: linear-gradient(135deg, var(--brand), #2b90ff); border-color: transparent; }
        .ram-btn.ghost { background: rgba(255,255,255,.03); }

        .ram-hero { padding: 56px 0 26px; position: relative; }
        .ram-hero h1 {
          font-size: clamp(48px, 3.8vw, 60px);
          line-height: 1.15;
          margin: 0 0 16px;
          letter-spacing: .3px;
          word-spacing: .5px;
        }
        .ram-hero p {font-size: clamp(15px, 1.7vw, 15px); max-width: 880px; }
        .ram-tag {
          display:inline-flex; align-items:center; gap:8px; padding:6px 12px;
          border-radius:999px; background: rgba(11,92,255,.12); color:#cfe0ff;
          border:1px solid rgba(138,180,255,.25); font-weight:600; font-size:12px; cursor:pointer;
        }

        .ram-grid { display:grid; gap:18px; }
        .ram-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
        .ram-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
        .ram-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        @media (max-width: 1000px) { .ram-cols-4 { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 700px) { .ram-cols-4, .ram-cols-3, .ram-cols-2 { grid-template-columns: 1fr; } }

        .ram-card {  border:1px solid rgba(255,255,255,.06); border-radius: var(--card-radius); box-shadow: var(--shadow); padding: 20px 18px; }
        .ram-card h3 { margin: 0 0 8px; font-size: 24px;}
        .ram-card p { margin: 0; font-size: 15px}

        .ram-kv { display:flex; gap:12px; align-items:flex-start; padding: 14px 0; border-top: 1px dashed rgba(255,255,255,.08); }
        .ram-kv:first-child { border-top: 0; }
        .ram-k { flex: 0 0 160px; color:#cfe0ff; font-weight:700; text-transform:uppercase; letter-spacing:.6px; font-size:12px; }
        .ram-v { flex: 1; color: var(--text); }

        .ram-badges { display:flex; gap:8px; flex-wrap:wrap; }
        .ram-badge { display:inline-flex; align-items:center; gap:8px; padding:8px 12px; border-radius:12px; background: rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.08); font-weight:600; color: var(--text); }

        .ram-section { margin: 30px 0; }
        .ram-section h2 { font-size:22px; margin:0 0 8px; }
        .ram-muted { color: var(--muted); }

        .ram-headline { display:flex; align-items:center; gap:12px; margin:28px 0 10px;}
        .ram-headline h2{font-size: 28px;}
        .ram-rule { height:1px; background: linear-gradient(90deg, rgba(0,0,0,0), rgba(0,0,0,.2), rgba(0,0,0,0)); flex:1; }

        .ram-callout { border-left:3px solid var(--brand); background: rgba(11,92,255,.08); padding:14px 16px; border-radius:10px; }

        .ram-metrics { display:grid; grid-template-columns: repeat(4, minmax(0,1fr)); gap:12px; margin-top:12px; }
        .ram-metric { text-align:center; padding:16px; border-radius:14px; background: rgba(255,255,255,.04); border:1px solid rgba(0,0,0,.08); }
        .ram-metric h4 { margin:0 0 4px; font-size:20px; }
        .ram-metric p { margin:0; font-size:14px; }
        @media (max-width: 1000px) { .ram-metrics { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 700px) { .ram-metrics { grid-template-columns: 1fr; } }

        .ram-footer { margin: 40px 0 20px; color: var(--muted); font-size: 13px; text-align:center; }

        /* Dropdown */
        .ram-menu {
          position:absolute;
          background-color:#0f131a;
          min-width:260px;
          z-index:10;
          border-radius:10px;
          box-shadow: var(--shadow);
          border:1px solid rgba(255,255,255,.12);
          margin-top:8px;
        }
        .ram-menu a { color: var(--text); padding:12px; text-decoration:none; display:block; }
        .ram-menu a:hover { background-color: var(--brand-2); }

        @media print {
          .ram-header { display:none; }
          .ram-root { background:#fff; color:#111; }
          .ram-card { background:#fff; border-color:#ddd; box-shadow:none; }
          .ram-hero .ram-tag { background:#e9f1ff; color:#0b5cff; border-color:#c9ddff; }
        }
      `}</style>

      <div className="ram-root">
        {/* Page header (under HomeHeader) */}

        <main className="ram-container" style={{ paddingTop: "0px" }}>
          <Box className="w-full pt-24 pb-24">
            <Container maxWidth="lg">
              <Box className="w-full text-center px-6 pt-16">
                <Box
                  className="w-full"
                  paddingBottom={3}
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <img
                    className="docuChalee-logo"
                    src={riteCover}
                    alt="seecharlee-ico"
                  />
                  <h5
                    className="docuChalee-logoTxt text-[29px] leading-[40px] font-medium mx-2"
                    data-aos="flip-right"
                    data-aos-duration="1000"
                  >
                    RiteCharlee
                  </h5>
                </Box>
                <h2 className="riteCharlee-head overflow-y-hidden text-[40px] md:text-[65px] leading-[45px] md:leading-[71.5px] font-medium">
                  Risk Intelligence for Better Selection & <br />
                  Smarter Products
                </h2>

                <p className="riteCharlee-explanation text-[16px] py-5 ">
                  Built on insights from 60M+ real world claims, RiteCharlee
                  gives underwriting, actuarial, risk managers, operation
                  managers and product teams the risk insights and intelligence
                  they need to select the right risks, price with confidence,
                  proactively reduce/control losses based on risk benchmarks and
                  design offerings that perform in market.
                </p>
                <button
                  onClick={() => handleOpenBook()}
                  className="docuChalee-book mt-6 w-full md:w-auto rounded-full text-[18px] leading-[24px] bg-transparent border py-3 px-10 border-[#021744] text-[#021744] hover:text-white hover:bg-[#021744]"
                  data-aos="flip-down"
                  data-aos-delay="3000"
                  data-aos-duration="1000"
                >
                  Book a demo
                </button>
              </Box>
            </Container>
          </Box>

          <Grid2 container spacing={2}>
            <Grid2
              size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
              data-aos="fade-up"
              data-aos-delay="1000"
            >
              <section
                className="ram-grid ram-cols-2 riteCharlee-features"
                display={"flex"}
              >
                <div className="ram-card">
                  <h3 style={{ fontWeight: "bold" }}>Sharper Selection</h3>
                  <p>
                    Score new submissions and renewals against real world loss
                    patterns by segment, peril, and venue.
                  </p>
                </div>
                <div className="ram-card">
                  <h3 style={{ fontWeight: "bold" }}>Pricing Signals</h3>
                  <p>
                    Surface severity frequency drivers to inform rate, limits,
                    deductibles, and attachment points.
                  </p>
                </div>
                <div className="ram-card">
                  <h3 style={{ fontWeight: "bold" }}>Product Design</h3>
                  <p>
                    Identify coverage gaps and feature opportunities from claim
                    outcome trends and exposures.
                  </p>
                </div>
                <div className="ram-card">
                  <h3 style={{ fontWeight: "bold" }}>Portfolio Foresight</h3>
                  <p>
                    Spot emerging risks and regional shifts early to rebalance
                    appetite and growth strategy.
                  </p>
                </div>
                <div className="ram-card">
                  <h3 style={{ fontWeight: "bold" }}>Risk Benchmarks</h3>
                  <p>
                    Leverage segmented risk benchmarks and compare to
                    operations’ data to understand and control pr prevent losses
                    and come up with mitigation strategies.
                  </p>
                </div>
              </section>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <div className="riteCharlee-dashboard flex justify-center items-center">
                <img
                  src={riteCharleeDashboard}
                  alt="RiteCharlee-dashboard"
                  className="w-full"
                  style={{ maxWidth: "200vw" }}
                  data-aos="fade-left"
                  data-aos-delay="1000"
                />
              </div>
            </Grid2>
          </Grid2>

          <section className="ram-section">
            <div className="ram-headline">
              <h2
                style={{ margin: 0, fontWeight: "bold" }}
                data-aos="fade-right"
              >
                How RiteCharlee Works
              </h2>
              <div className="ram-rule" />
            </div>
            <div className="ram-grid ram-card ram-cols-1">
              <section className="ram-grid ram-cols-3" data-aos="fade-up">
                <div className="">
                  <h3 style={{ fontWeight: "bold" }}>
                    1) Claim Grounded Signals
                  </h3>
                  <p>
                    Domain tuned NLP and pattern mining across 60M+ claims
                    extract causal drivers of loss: injury and damage types,
                    treatment pathways, venue effects, party roles, entity
                    behavior, and time to event milestones.
                  </p>
                </div>
                <div className="">
                  <h3 style={{ fontWeight: "bold" }}>
                    2) Risk & Product Scoring
                  </h3>
                  <p>
                    Submission level and segment level scores for severity,
                    litigation likelihood, and loss amplification, risk signals
                    —each with explainable factors and confidence bands.
                  </p>
                </div>
                <div className="">
                  <h3 style={{ fontWeight: "bold" }}>3) Action in Workflow</h3>
                  <p>
                    Scores and explanations delivered via APIs, underwriting
                    workbench widgets, and dashboards—plus Charlee AI Agents for
                    appetite checks and what if exploration.
                  </p>
                </div>
              </section>
              <div className="ram-rule" />
              <Grid2 container spacing={{ xs: 1, sm: 5 }}>
                <Grid2 size={{ xs: 12, sm: 2 }}>
                  <b>Integrations</b>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 10 }}>
                  <span>
                    Native APIs • Underwriting workbenches • Data lakes • Policy
                    admin/Rating • Claims systems • (Guidewire, Duck Creek,
                    Masjesco and more)
                  </span>
                </Grid2>
              </Grid2>
            </div>
          </section>

          <section className="ram-section">
            <div className="ram-headline">
              <h2
                style={{ margin: 0, fontWeight: "bold" }}
                data-aos="fade-right"
              >
                High-Impact Use Cases
              </h2>
              <div className="ram-rule" />
            </div>
            <section className="ram-grid ram-cols-3">
              <div className="ram-card" data-aos="fade-up">
                <h3 style={{ fontWeight: "bold" }}>
                  Operational Risk Detection
                </h3>
                <p>
                  Integrate Charlee’s real-time intelligence with
                  core/operational systems and surveillance analytics to detect
                  exposures—alerting operators to potential liability events
                  before they escalate.
                </p>
              </div>
              <div className="ram-card" data-aos="fade-up">
                <h3 style={{ fontWeight: "bold" }}>
                  Incident Severity Prediction
                </h3>
                <p>
                  Leverage Charlee’s claims-trained severity models to classify
                  on-site incidents by predicted medical cost, litigation risk,
                  and reputational exposure. Prioritize response and
                  documentation workflows accordingly.
                </p>
              </div>
              <div className="ram-card" data-aos="fade-up">
                <h3 style={{ fontWeight: "bold" }}>
                  Workforce Safety Insights
                </h3>
                <p>
                  Correlate payroll, shift patterns, and training records with
                  injury trends to identify high-risk roles, time windows, or
                  procedural gaps. Enable targeted safety training and staffing
                  adjustments.
                </p>
              </div>
              <div className="ram-card" data-aos="fade-up">
                <h3 style={{ fontWeight: "bold" }}>
                  Policy & Compliance Optimization
                </h3>
                <p>
                  Cross-reference operator SOPs and policy terms to flag
                  non-compliance risks (e.g., alcohol service, kitchen hazards,
                  security protocols) that may increase exposure or void
                  coverage.
                </p>
              </div>
              <div className="ram-card" data-aos="fade-up">
                <h3 style={{ fontWeight: "bold" }}>
                  Premium & Claims Optimization
                </h3>
                <p>
                  Feed aggregated operational and behavioral data into
                  underwriting models to enable dynamic, usage-based
                  premiums—rewarding operators with lower risk signals and
                  proactive prevention behaviors.
                </p>
              </div>
              <div className="ram-card" data-aos="fade-up">
                <h3 style={{ fontWeight: "bold" }}>
                  Benchmarking & Peer Comparisons
                </h3>
                <p>
                  Benchmark venue risk signals against anonymized industry peers
                  (restaurants, bars, cafés, hotels) to guide loss prevention
                  and insurance negotiations.
                </p>
              </div>
              <div className="ram-card" data-aos="fade-up">
                <h3 style={{ fontWeight: "bold" }}>Portfolio Intelligence</h3>
                <p>
                  For insurers and brokers, use aggregated signals across
                  operators to identify emerging trends (e.g., kitchen burns,
                  security incidents) and adjust appetite or pricing across
                  hospitality classes.
                </p>
              </div>
            </section>
          </section>

          <section className="ram-section">
            <div className="ram-headline">
              <h2
                style={{ margin: 0, fontWeight: "bold" }}
                data-aos="fade-right"
              >
                Business Value
              </h2>
              <div className="ram-rule" />
            </div>
            <div className="ram-card" data-aos="fade-up">
              <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li>
                  Reduce loss ratio volatility with earlier detection of
                  severity and litigation drivers.
                </li>
                <li>
                  Improve hit ratio on in appetite risks while curbing adverse
                  selection.
                </li>
                <li id="financial-impact">
                  Accelerate time to underwrite through triage and explainable
                  scoring.
                </li>
                <li>
                  Inform rate filings and claim product updates with grounded
                  evidence.
                </li>
              </ul>
              <div className="ram-metrics">
                <div
                  className="ram-metric"
                  aria-label="Reserve accuracy improvement"
                >
                  <h4>15–30%</h4>
                  <p>fewer high severity surprises in target segments</p>
                </div>
                <div
                  className="ram-metric"
                  aria-label="Late adjustments reduction"
                >
                  <h4>5–10 pts</h4>
                  <p>improvement in risk adjusted hit ratio</p>
                </div>
                <div className="ram-metric" aria-label="Time to value">
                  <h4>40% faster</h4>
                  <p>Dashboards ready; rapid time-to-value</p>
                </div>
                <div className="ram-metric" aria-label="Time to value">
                  <h4>Weeks → Days</h4>
                  <p>signal delivery for new initiatives</p>
                </div>
              </div>
            </div>
          </section>

          <section className="ram-section">
            <div className="ram-headline">
              <h2
                style={{ margin: 0, fontWeight: "bold" }}
                data-aos="fade-right"
              >
                Security, Privacy & Ethical AI
              </h2>
              <div className="ram-rule" />
            </div>
            <div className="ram-card" data-aos="fade-up">
              <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li>
                  Data residency and access controls aligned to carrier
                  policies.
                </li>
                <li>
                  PII handling, encryption in transit/at rest, and audit trails
                </li>
                <li>
                  Explainable factors on every score; bias and drift monitoring
                  across segments.
                </li>
                <li id="financial-impact">
                  Governance aligned to Charlee’s ethical AI principles.
                </li>
              </ul>
            </div>
          </section>

          {/* <section className="ram-grid ram-cols-2 ram-section">
            <div className="ram-card">
              <h3 style={{ fontWeight: "bold" }}>Before Charlee</h3>
              <p>
                Spreadsheet-driven manual review of open claims for reserve
                adjustments, IBNR irregularities, and reserving/profitability
                issues.
              </p>
            </div>
            <div className="ram-card">
              <h3 id="product" style={{ fontWeight: "bold" }}>
                With Charlee
              </h3>
              <p>
                AI continuously monitors reserves vs. predicted incurred, flags
                under- and over-reserved risks, and surfaces high-impact claims
                for review.
              </p>
            </div>
          </section>

          <section className="ram-section">
            <div className="ram-grid ram-cols-3">
              <div className="ram-card">
                <h3 style={{ fontWeight: "bold" }}>Product Used</h3>
                <div className="ram-badges">
                  <span className="ram-badge">🔎 4SeeCharlee</span>
                </div>
              </div>
              <div className="ram-card">
                <h3 style={{ fontWeight: "bold" }}>LOBs</h3>
                <div className="ram-badges">
                  <span className="ram-badge">All</span>
                </div>
              </div>
              <div className="ram-card" id="value">
                <h3 style={{ fontWeight: "bold" }}>Area</h3>
                <div className="ram-badges">
                  <span className="ram-badge">Claims</span>
                  <span className="ram-badge">Reserves</span>
                </div>
              </div>
            </div>
          </section>

          <section className="ram-section">
            <div className="ram-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>
                Value Proposition
              </h2>
              <div className="ram-rule" />
            </div>
            <div className="ram-card">
              <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li>
                  Early reserve adequacy assessment benefits both present and
                  future processes.
                </li>
                <li>
                  Claims can be reviewed sooner based on claim age, potentially
                  accelerating reserve decisions.
                </li>
                <li>
                  Early reviews ensure timely data collection, improving
                  outcomes and reducing litigation.
                </li>
                <li id="financial-impact">
                  Increased productivity and precision in financial reporting
                  and reserve setting.
                </li>
                <li>
                  Insights can be used to train staff and improve long-term
                  reserve practices.
                </li>
              </ul>
            </div>
          </section>

          <section className="ram-section">
            <div className="ram-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>
                Financial Impact
              </h2>
              <div className="ram-rule" />
            </div>
            <div className="ram-card">
              <p className="ram-muted">Inaccurate reserves can lead to:</p>
              <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li>
                  Regulatory scrutiny, particularly when under-reserving forces
                  late reserve strengthening
                </li>
                <li>
                  Over-reserving, tying up capital and inflating liability
                  estimates
                </li>
                <li>
                  Late adjustments, distorting financial reports and
                  complicating reinsurance/actuarial operations
                </li>
              </ul>
              <div className="ram-callout" style={{ marginTop: 12 }}>
                <strong>Charlee delivers:</strong>
                <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                  <li>
                    $5K–$15K estimated savings per under-reserved claim due to
                    early corrections
                  </li>
                  <li>
                    Reduced capital drag by optimizing over-reserved claims
                  </li>
                  <li>Avoidance of reserve leakage and surprise adjustments</li>
                  <li>
                    Improved quarter/year-end closing accuracy and stability
                  </li>
                  <li>
                    Millions in reported reserve optimization gains from
                    real-world deployments
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="ram-section">
            <div className="ram-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Results</h2>
              <div className="ram-rule" />
            </div>
            <div className="ram-card">
              <div className="ram-metrics">
                <div
                  className="ram-metric"
                  aria-label="Reserve accuracy improvement"
                >
                  <h4>📈 18%</h4>
                  <p>improvement in reserve accuracy</p>
                </div>
                <div
                  className="ram-metric"
                  aria-label="Late adjustments reduction"
                >
                  <h4>✅ 30%</h4>
                  <p>reduction in late reserve adjustments</p>
                </div>
                <div className="ram-metric" aria-label="Customer quote">
                  <h4>💬</h4>
                  <p>
                    “Now our actuaries, supervisors, and adjusters are finally
                    aligned.”
                  </p>
                </div>
                <div className="ram-metric" aria-label="Time to value">
                  <h4>⏱️ 2 weeks</h4>
                  <p>Dashboards ready; rapid time-to-value</p>
                </div>
              </div>
            </div>
          </section>

          <section className="ram-section">
            <div className="ram-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Why It Matters</h2>
              <div className="ram-rule" />
            </div>
            <div className="ram-card">
              <p>
                Early detection of reserve mismatches prevents leakage, reduces
                volatility in financial reporting, and improves capital
                efficiency.
              </p>
            </div>
          </section> */}
        </main>
        <BookPopup open={isOpenBook} handleClose={handleCloseBook} />
      </div>
    </div>
  );
};
